import { createSelector } from '@reduxjs/toolkit';
import { type StudentDashboardState } from './studentDashboardSlice.types';

export const getStudentDashboardState = (state: { studentDashboard: StudentDashboardState }) => state.studentDashboard;

export const getHasSeenExecEdEligibilityModal = createSelector(
    getStudentDashboardState,
    studentDashboardState => studentDashboardState.hasSeenExecEdEligibilityModal,
);

export const getPendingFocusedProjectRequirementIdentifier = createSelector(
    getStudentDashboardState,
    studentDashboardState => studentDashboardState.pendingFocusedProjectRequirementIdentifier,
);

export const getPendingViewProjectFeedbackRequirementIdentifier = createSelector(
    getStudentDashboardState,
    studentDashboardState => studentDashboardState.pendingViewProjectFeedbackRequirementIdentifier,
);

export const getForceExpandedItems = createSelector(
    getStudentDashboardState,
    studentDashboardState => studentDashboardState.forceExpandedItems,
);

export const getMobileDrawerShouldHide = createSelector(
    getStudentDashboardState,
    studentDashboardState => studentDashboardState.mobileDrawerShouldHide,
);
